import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
    <path d="M46.4,41.7H11.9a3.59,3.59,0,0,1-3.6-3.6V3.6A3.59,3.59,0,0,1,11.9,0H46.4A3.59,3.59,0,0,1,50,3.6V38.1A3.59,3.59,0,0,1,46.4,41.7ZM12.1,37.9h34V3.9h-34Zm14.6-7.2h4.9V23.3h7.3V18.4H31.6V11.1H26.7v7.3H19.3v4.9h7.4ZM31,46.1H3.9V19a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1V49a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V47.1A1,1,0,0,0,31,46.1Z" />
  </svg>
);
